var React = require('react');

function CardsCtaInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.86856 1.84636H4.6137H2.76734V0H11.9991V9.23179H10.1528V7.38543V3.17329L1.30557 12.0205L0 10.7149L8.86856 1.84636Z","fill":"#FF00FF"}));
}

CardsCtaInline.defaultProps = {"width":"12","height":"13","viewBox":"0 0 12 13","fill":"none"};

module.exports = CardsCtaInline;

CardsCtaInline.default = CardsCtaInline;
